import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./TransportNavbar.css";

const TransportNavbar = () => {
  const navigate = useNavigate();

  const transportUser = JSON.parse(localStorage.getItem("transportUser") || "null");
  const username = transportUser?.username;

  // 🔐 Rechten per gebruiker
  const canHome =
    username === "hermus" || username === "wpk" || username === "adwpk" || username === "andy" || username === "wijk" || username === "nover" || username === "tjalko" || username === "peter" || username === "briem";
  const canFust =
    username === "hermus" || username === "wpk" || username === "adwpk" || username === "andy" || username === "wijk" || username === "nover" || username === "tjalko" || username === "peter" || username === "briem";
  const canWarehouse =
    username === "hal" || username === "adwpk" || username === "andy" || username === "tjalko" || username === "peter";

  const handleLogout = () => {
    localStorage.removeItem("transportUser"); // Transport gebruiker uitloggen
    navigate("/transport/login"); // Stuur terug naar login pagina
  };

  return (
    <nav className="transport-navbar">
      <ul>
        {canHome && (
          <li>
            <Link to="/transport/home">🚛 Transport melden</Link>
          </li>
        )}

        {canFust && (
          <li>
            <Link to="/transport/fust">📦 Retourfust</Link>
          </li>
        )}

        {canWarehouse && (
          <li>
            <Link to="/transport/warehouse">🏭 Magazijn</Link>
          </li>
        )}

        <li>
          <button onClick={handleLogout} className="logout-button">
            🚪 Uitloggen
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default TransportNavbar;
